import { render, staticRenderFns } from "./NewPostModal.vue?vue&type=template&id=1dd4d016"
import script from "./NewPostModal.vue?vue&type=script&lang=js"
export * from "./NewPostModal.vue?vue&type=script&lang=js"
import style0 from "./NewPostModal.vue?vue&type=style&index=0&id=1dd4d016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports